// extracted by mini-css-extract-plugin
export default {"checkbox":"nTdAEulFqJ"};